@if (message && message.length > 0) {
  <div class="message-text">{{ message }}</div>
}
<div class="loadingContainer">
  <div class="ball ball1"></div>
  <div class="ball ball2"></div>
  <div class="ball ball3"></div>
  <div class="ball ball4"></div>
  <div class="ball ball5"></div>
</div>
